import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=db6c9ab4&"
import script from "./privacy_policy.vue?vue&type=script&lang=js&"
export * from "./privacy_policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports